import { Injectable } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { Router } from "@angular/router";
import { geolocalizationService } from "@core/services/geolocalization";
import { manageStorageService } from "@core/services/manage-storage/manage-storage.service";
import { AuthService } from "app/configuration/auth/auth.service";
import { environment } from "environments/environment";
import Swal from "sweetalert2/dist/sweetalert2.js";

/**
 * Servicio encargado de gestionar el flujo central de cierre de sesión en la aplicación.
 * Orquesta la limpieza del almacenamiento local, cierra modales activos, notifica la 
 * geolocalización al backend y redirige al usuario con base en la petición de origen.
 */
@Injectable({ providedIn: 'root' })
export class SignOutService {

  // -----------------------------------------------------------------------------------------------------
  // @ Decorators
  // -----------------------------------------------------------------------------------------------------

  // -----------------------------------------------------------------------------------------------------
  /** constructor  */
  // -----------------------------------------------------------------------------------------------------
  constructor(
    private _mStorage: manageStorageService,
    private _authService: AuthService,
    private _router: Router,
    private _geoS: geolocalizationService,
    private modalsApp: MatDialog // all windows
  ) { }
  // -----------------------------------------------------------------------------------------------------
  // @ Public declaration vars
  // -----------------------------------------------------------------------------------------------------

  // -----------------------------------------------------------------------------------------------------
  // @ Private declaration vars
  // -----------------------------------------------------------------------------------------------------


  // -----------------------------------------------------------------------------------------------------
  // @ Lifecycle hooks
  // -----------------------------------------------------------------------------------------------------

  // -----------------------------------------------------------------------------------------------------
  // @ Private methods
  // -----------------------------------------------------------------------------------------------------

  /**
   * Navega hacia la vista principal de login y recarga la ventana.
   */
  private _navigateToLogin(): void {
    this._router.navigate(["login"]);
    setTimeout(() => { window.location.reload(); }, 100);
  }

  /**
   * Ejecuta el cierre de sesión, limpia el almacenamiento y redirige según el origen.
   * 
   * @param {string} origin Origen de la petición.
   */
  private _executeSignOut(origin: string): void {
    this._authService.signOut();
    this._mStorage.clearStorage("all");
    this.modalsApp.closeAll();

    if (origin === 'navigate') { this._router.navigate(["/sign-out"]); } 
    else { this._navigateToLogin(); }
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Public methods
  // -----------------------------------------------------------------------------------------------------
  /**
   * Ejecuta el proceso integral de cierre de sesión del usuario.
   * Envía la ubicación geográfica del último evento, limpia la sesión local (`authService`, `storage`),
   * garantiza el cierre forzoso de cualquier contenedor visual abierto (sweet alerts, modals) y redirige.
   * 
   * @param {string} [origin='navigate'] - Cadena que determina la ruta de redirección tras la limpieza. 
   *                                     Si es igual a `'navigate'`, redirige al componente `/sign-out`, 
   *                                     de lo contrario, redirige a la vista principal del `/login` y recarga la ventana.
   * @returns {void}
   */
  public processToLogOut(origin: string = 'navigate'): void {
    Swal.close();

    if (environment.activeGeo) {
      try {
        this._geoS.putGeoInWS('90900')
        this._executeSignOut(origin)
      } catch (error) { this._navigateToLogin(); }
    } else { this._executeSignOut(origin); }
  }

}